import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from './grid.module';
import { Filter, Page, Selection, Sort, Group, Reorder, RowDD, DetailRow, Toolbar, Aggregate, Search, VirtualScroll, Edit, Resize, ExcelExport, PdfExport, CommandColumn, ContextMenu, Freeze, ColumnMenu, ColumnChooser, ForeignKey } from '@syncfusion/ej2-grids';
export var FilterService = { provide: 'GridsFilter', useValue: Filter };
export var PageService = { provide: 'GridsPage', useValue: Page };
export var SelectionService = { provide: 'GridsSelection', useValue: Selection };
export var SortService = { provide: 'GridsSort', useValue: Sort };
export var GroupService = { provide: 'GridsGroup', useValue: Group };
export var ReorderService = { provide: 'GridsReorder', useValue: Reorder };
export var RowDDService = { provide: 'GridsRowDD', useValue: RowDD };
export var DetailRowService = { provide: 'GridsDetailRow', useValue: DetailRow };
export var ToolbarService = { provide: 'GridsToolbar', useValue: Toolbar };
export var AggregateService = { provide: 'GridsAggregate', useValue: Aggregate };
export var SearchService = { provide: 'GridsSearch', useValue: Search };
export var VirtualScrollService = { provide: 'GridsVirtualScroll', useValue: VirtualScroll };
export var EditService = { provide: 'GridsEdit', useValue: Edit };
export var ResizeService = { provide: 'GridsResize', useValue: Resize };
export var ExcelExportService = { provide: 'GridsExcelExport', useValue: ExcelExport };
export var PdfExportService = { provide: 'GridsPdfExport', useValue: PdfExport };
export var CommandColumnService = { provide: 'GridsCommandColumn', useValue: CommandColumn };
export var ContextMenuService = { provide: 'GridsContextMenu', useValue: ContextMenu };
export var FreezeService = { provide: 'GridsFreeze', useValue: Freeze };
export var ColumnMenuService = { provide: 'GridsColumnMenu', useValue: ColumnMenu };
export var ColumnChooserService = { provide: 'GridsColumnChooser', useValue: ColumnChooser };
export var ForeignKeyService = { provide: 'GridsForeignKey', useValue: ForeignKey };
/**
 * NgModule definition for the Grid component with providers.
 */
var GridAllModule = /** @class */ (function () {
    function GridAllModule() {
    }
    GridAllModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, GridModule],
                    exports: [
                        GridModule
                    ],
                    providers: [
                        FilterService,
                        PageService,
                        SelectionService,
                        SortService,
                        GroupService,
                        ReorderService,
                        RowDDService,
                        DetailRowService,
                        ToolbarService,
                        AggregateService,
                        SearchService,
                        VirtualScrollService,
                        EditService,
                        ResizeService,
                        ExcelExportService,
                        PdfExportService,
                        CommandColumnService,
                        ContextMenuService,
                        FreezeService,
                        ColumnMenuService,
                        ColumnChooserService,
                        ForeignKeyService
                    ]
                },] },
    ];
    /** @nocollapse */
    GridAllModule.ctorParameters = function () { return []; };
    return GridAllModule;
}());
export { GridAllModule };
//# sourceMappingURL=grid-all.module.js.map